import * as R from 'ramda';
import React from 'react';

import { getIn } from 'reactApp/components/Forms/formUtils';

import { connectFormikContext } from './ConnectFormikContext';
import { FieldInput } from './FieldInput';

@connectFormikContext()
export class FieldDependentValue extends React.Component {
    UNSAFE_componentWillMount() {
        const { name } = this.props;

        if (this._getShouldGenerate() && !getIn(this._getValues(), name)) {
            this._generateValue();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { dependentFieldNames } = this.props;
        const prevValues = this._getValues(this.props);
        const nextValues = this._getValues(nextProps);
        if (this._getShouldGenerate() && prevValues !== nextValues) {
            const prevDependentValues = {};
            const nextDependentValues = {};

            dependentFieldNames.map((fieldName) => {
                prevDependentValues[fieldName] = getIn(prevValues, fieldName);
                nextDependentValues[fieldName] = getIn(nextValues, fieldName);
            });

            const isDependentValuesChanged = !R.equals(
                prevDependentValues,
                nextDependentValues,
            );

            if (isDependentValuesChanged) {
                this._generateValue(nextValues);
            }
        }
    }

    _generateValue = (values = this._getValues()) => {
        const {
            _formikContext,
            name,
            generateValue,
            validateOnGeneratedValueChange,
        } = this.props;
        _formikContext.setFieldValue(
            name,
            generateValue(values),
            validateOnGeneratedValueChange,
        );
    };

    _getValues = (props = this.props) =>
        props.values || props._formikContext.values;

    _getIsTouched = (props = this.props) =>
        getIn(props._formikContext.changedByUser, props.name);

    _getShouldGenerate = (props = this.props) =>
        props.shouldStopWhenTouched ? !this._getIsTouched() : true;

    _getIsDisabled = (props = this.props) =>
        props.getIsDisabled
            ? props.getIsDisabled(this._getValues())
            : props.disabled;

    render() {
        const {
            name,
            label,
            _formikContext,
            generateValue,
            dependentFieldNames,
            values,
            disabled,
            getIsDisabled,
            shouldStopWhenTouched,
            fieldControl,
            control,
            dataTest,
            validateOnGeneratedValueChange,
            ...otherControlProps
        } = this.props;
        const Control = fieldControl || control || FieldInput;

        return (
            <Control
                dataTest={dataTest}
                label={label}
                name={name}
                disabled={this._getIsDisabled()}
                {...otherControlProps}
            />
        );
    }
}
